import WidgetsIcon from '@material-ui/icons/Widgets';

import List from './List';

export default {
  list: List,
  icon: WidgetsIcon,
};
